import React from 'react';
import { cn } from '@/lib/cn';

export interface DividerProps {
  /**
   * The visual style variant of the divider
   * @default "secondary"
   */
  variant?: 'secondary' | 'tertiary';
  /**
   * The orientation of the divider
   * @default "horizontal"
   */
  orientation?: 'horizontal' | 'vertical';
  /**
   * Additional CSS classes to apply to the divider
   */
  className?: string;
}

export function Divider({
  variant = 'secondary',
  orientation = 'horizontal',
  className,
}: DividerProps) {
  if (orientation === 'vertical') {
    return (
      <div
        className={cn(
          // Layout - vertical divider (height should be set via className)
          'w-px',
          'border-l',
          // Appearance - use semantic border colors from design system
          variant === 'tertiary' ? 'border-tertiary' : 'border-secondary',
          className,
        )}
        role="separator"
        aria-orientation="vertical"
      />
    );
  }

  return (
    <div
      className={cn(
        // Layout - horizontal divider
        'w-full h-px',
        'border-b',
        // Appearance - use semantic border colors from design system
        variant === 'tertiary' ? 'border-tertiary' : 'border-secondary',
        className,
      )}
      role="separator"
      aria-orientation="horizontal"
    />
  );
}
